import client from '../session/apiClient'

const workflowNotificationsApi = {
  listNotifications({offset = 0, limit = 20}) {
    return client.get('/user/notifications', {params: {offset, limit}}).then(resp => resp.data.notifications)
  },

  markNotificationsViewed() {
    return client.put('/user/notifications/viewed', {params: {time: Date.now()}})
  },

  getNotificationSettings() {
    return client.get('/user/notifications/settings').then(resp => resp.data.settings)
  }
}

export default workflowNotificationsApi
